import cn from 'classnames';
import React, { Fragment } from 'react';

type FeeDisplay = {
    value: React.ReactNode;
    label?: string;
    highlight?: 'success' | 'error';
};

export type FeeDisplayProps = {
    items?: FeeDisplay[];
    defaultLabel?: string;
    isLoading?: boolean;
    isError?: boolean;
};

const FeeDisplay = ({ items, defaultLabel, isLoading, isError }: FeeDisplayProps) => {
    return items ? (
        <div
            className={cn('text-sm text-brand-text rounded-sm flex flex-col gap-3', {
                'animate-pulse': isLoading && !items
                // 'bg-brand-neutral-500': isError,
                // 'bg-brand-neutral-700': !isError && !isLoading
            })}>
            {items.length > 0 ? (
                <>
                    {items?.map((item, index) => {
                        const label = item.label ?? defaultLabel;

                        return (
                            <Fragment key={index}>
                                <div className="flex justify-between items-center">
                                    <span className="text-brand-text">
                                        {label}

                                        {items.length > 1 && ` (${index + 1})`}
                                    </span>

                                    <span
                                        className={cn({
                                            'text-brand-green-light': item.highlight === 'success',
                                            'text-brand-red-light': item.highlight === 'error',
                                            'text-brand-neutral-100': !item.highlight
                                        })}>
                                        {item.value}
                                    </span>
                                </div>

                                {/* {index < items.length - 1 && <Divider />} */}
                            </Fragment>
                        );
                    })}
                </>
            ) : (
                <span className="text-sm">{defaultLabel}</span>
            )}
        </div>
    ) : (
        <></>
    );
};

export default FeeDisplay;
